import { render, staticRenderFns } from "./CookiesPolicy.vue?vue&type=template&id=5bfd5f58&scoped=true&"
import script from "./CookiesPolicy.vue?vue&type=script&lang=ts&"
export * from "./CookiesPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./CookiesPolicy.vue?vue&type=style&index=0&id=5bfd5f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfd5f58",
  null
  
)

export default component.exports